if (!customElements.get('confirmation-popup')) {
  class ConfirmationPopup extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        closeHandler: '.js-close-confirmation-popup',
        confirmationPopup: '.confirmation-popup',

        confirmationPopupActiveClass: 'confirmation-popup--active',
      };

      this.closeHandler = document.querySelector(this.selectors.closeHandler);
      this.closeHandler.addEventListener('click', this.closePopUp.bind(this));
    }

    closePopUp() {
      const confirmationPopup = document.querySelector(this.selectors.confirmationPopup);

      confirmationPopup.classList.remove(this.selectors.confirmationPopupActiveClass);
    }
  }

  customElements.define('confirmation-popup', ConfirmationPopup);
}
